<template>
	<div>
		<navigation></navigation>
		<div class="line"></div>
		<div style="width: 90% ;margin: 0 auto;">
			<p>
				<br />
			</p>
			<p class="MsoNormal">
				<span style="font-size:16px;"><strong><span style="color:rgb(20, 90, 245);">地点：</span></strong><span style="color:#666666;">上海跨国采购会展中心</span></span><br />

			</p>
			<p>
				<span style="font-size:16px;"><span style="color:rgb(20, 90, 245);"><strong>地址：</strong></span><span style="color:#666666;">上海市普陀区光复西路
						2739 号</span></span>
			</p>
			<p>
				<br />
			</p>
			<p>
				<strong><span style="color:rgb(20, 90, 245);">会场入口请从上海跨国采购会展中心-南一门入（光复西路中江路口）</span></strong>
			</p>
			<p>
				<br />
			</p>
			<p>
				<strong><span style="color:rgb(20, 90, 245);">地铁线路</span></strong>
			</p>
			<p>
				<br />
			</p>
			<span style="font-size:16px;color:#666666;"><strong><span style="color:#000000;">地铁 15 号线</span></strong>：地铁15号线
				长风公园站 3号口出（距离会场约730米）</span><br />


			<p>
				<br />
			</p>
			<p>
				<span style="font-size:16px;color:#666666;"><strong><span style="color:#000000;">地铁 2 号线</span></strong>：<span
					 style="color:#666666;">威宁路站4号口出（距离会场约1.3公里）</span></span>
			</p>

			<p>
				<br />
			</p>
			<p>
				<span style="font-size:16px;color:#666666;"><strong><span style="color:#000000;">地铁 13 号线</span></strong>：<span
					 style="color:#666666;">大渡河路站3号口出（距离会场约1.7公里）</span></span>
			</p>
			<p>
				<br />
			</p>
			<p>
				<strong><span style="color:rgb(20, 90, 245);">公交线路</span></strong>
			</p>
			<p>
				<br />
			</p>
			<p><span style="font-size:16px;color:#666666;">云岭东路：44、551 等</span><br /></p>
			<p><span style="font-size:16px;color:#666666;">大渡河路：141、长征 2 路等</span><br /></p>
			<p><span style="font-size:16px;color:#666666;">古北路：316、54、944、757 等</span><br /></p>

			<p>
				<span style="font-size:16px;color:#666666;"><span style="color:#666666;">天山西路：71、72、74、141、311、808、251、825、829、856、941、944、190
						等</span></span>
			</p>
			<p>
				<br />
			</p>
			<p>
				<strong><span style="color:rgb(20, 90, 245);">驾车线路</span></strong>
			</p>
			<p>
				<br />
			</p>
			<span style="font-size:16px;color:#666666;">延安路高架娄山关路匝道口下，于娄山关路右转，直行至天山西路左转，到古北路右转，上古北路桥，下桥后光复西路左转，直行至中江路即可到达；</span><br />

			<p>
				<br />
			</p>
			<span style="font-size:16px;color:#666666;">内环高架金沙江路匝道口下，沿金沙江路直行，到大渡河路左转，至云岭东路右转，到中江路左转即可到达；</span><br />


			<p>
				<br />
			</p>
			<p>
				<span style="font-size:16px;color:#666666;"><span style="color:#666666;">中环线金沙江路口下，沿金沙江路直行，至中江路右转即可到达；</span></span>
			</p>
			<p>
				<br />
			</p>
			<p>
				<strong><span style="color:rgb(20, 90, 245);">周边环境</span>&nbsp;</strong>
			<p>
				<br />
			</p>
			<p>
				<span style="font-size:16px;color:#666666;"><strong><span style="color:#000000;">机场：</span></strong><span style="color:#666666;">离虹桥机场
						1 号航站楼 8.8 公里，2 号航站楼 11 公里</span></span>
			</p>
			<p>
				<br />
			</p>
			<p>
				<span style="font-size:16px;color:#666666;"><strong><span style="color:#000000;">火车站：</span></strong><span style="color:#666666;">离虹桥火车站
						13 公里</span></span>
			</p>
			<p>
				<br />
			</p>
			<span style="font-size:16px;color:#666666;"><strong><span style="color:#000000;">周围地标：</span></strong>上海新发展亚太万豪酒店、成龙电影艺术馆、2
				号绿地游艇码头、国盛时尚绿色购物中心、长风公园等</span><br />

			<img src="../../../assets/zlan.png" style="width: 100%;margin-top: 30px;" />

			<br><br><br>
			<p>
				<strong><span style="color:rgb(20, 90, 245);">酒店推荐</span>&nbsp;</strong>
			</p>
			<div>
				<br>
				<span style="font-size:16px;color:#666666;"><strong><span style="color:#000000;">上海新发展亚太JW万豪酒店（VIP指定酒店）</span></strong></span>
				<br><br>
				<span style="font-size:16px;color:#666666;line-height: 30px"><span style="color:#666666;">地址：上海市普陀区大渡河路158号</span></span>
				<br>
				<span style="font-size:16px;color:#666666;line-height: 30px"><span style="color:#666666;">距离跨国采购会展中心800米</span></span>
				<br><br>

				<span style="margin-left: 30px;line-height: 30px;">
					<img src="../../../assets/checkbox.png" alt="" style="height: 20px">
					大床房：850元/间/夜（含单早）
				</span>
				<br>
				<span style="margin-left: 30px;line-height: 30px">
					<img src="../../../assets/checkbox.png" alt="" style="height: 20px">
					双床房：950元/间/夜（含双早）
				</span>
			</div>

			<div>
				<br>
				<span style="font-size:16px;color:#666666;"><strong><span style="color:#000000;">上海苏宁环球万怡酒店</span></strong></span>
				<br><br>
				<span style="font-size:16px;color:#666666;line-height: 30px"><span style="color:#666666;">地址：上海市普陀区丹巴路99号</span></span>
				<br>
				<span style="font-size:16px;color:#666666;line-height: 30px"><span style="color:#666666;">距离跨国采购会展中心1.2公里</span></span>
				<br><br>

				<span style="margin-left: 30px;line-height: 30px;">
					<img src="../../../assets/checkbox.png" alt="" style="height: 20px">
					单双同价：650元/间/夜（含早餐）
				</span>
				<br>
			</div>
			<br>
			<div>
				<span style="font-size:14px;color:#666666;"><strong>
						<span style="color:#000000;">酒店预订截止时间：2021年4月1日</span><br>
						<span style="color:#000000;">会议时间：2021年4月8-10日（周四-周六）</span><br>
						<span style="color:#000000;">会议地点：上海跨国采购会展中心召开（上海市普陀区光复西路2739号）</span><br>
					</strong></span>

				<br><br>
				<span style="font-size:16px;color:#666666;"><strong>
						<span style="color:#000000;text-decoration: underline">本次大会订房中心及联系人具体信息：</span><br><br>
						<span style="color:#666666;font-size:14px;color:#666666;line-height: 30px">联系人：彭悦</span><br>
						<span style="color:#666666;font-size:14px;color:#666666;line-height: 30px">电话：173 1728
							2021，021-64453107（转BISC感染会项目组）</span><br>
						<span style="color:#666666;font-size:14px;color:#666666;line-height: 30px">邮箱：pengyue@fumed.com.cn</span><br>
					</strong></span>

				<br><br>
				<span style="font-size:16px;color:#666666;"><strong>
						<span style="color:#000000;text-decoration: underline">预定指南：</span><br><br>
						<span style="color:#666666;font-size:14px;color:#666666;line-height: 30px;margin-left: 30px">会务组为参会嘉宾遴选了会场周边酒店，团队预订可联系订房中心预订并签订相关订房合同支付房费作为担保。参会个人/团队也可自行选择会场附近酒店进行安排住宿。凡未提前预订酒店的代表，大会将不保证会议期间的住宿，敬请自理。组委会提醒各位参会嘉宾尽早安排抵沪行程。</span><br>
						<span style="color:#666666;font-size:14px;color:#666666;line-height: 30px;margin-left: 30px">*
							需要电话咨询订房事宜的代表，请在工作日9:00-17:00拨打订房中心电话。</span><br>
					</strong></span>

				<br><br>
				<span style="font-size:16px;color:#666666;"><strong>
						<span style="color:#000000;text-decoration: underline">取消及退款：</span><br><br>
						<span style="color:#666666;font-size:14px;color:#666666;line-height: 30px;margin-left: 30px">如需更改/取消缴费后的订单，请于2021年4月1日前，以邮件方式联系订房中心此日期之后，您的订单将不可取消。团队预订变更请以合同条款为准。</span><br>
					</strong></span>


				<strong><a href="http://bisc2021.fumed.com.cn/hotel/m" style="color: #000000;"><span>点击以下链接预定住宿</span></a>
				</strong>
			</div>
		</div>
		<logocom></logocom>
	</div>
</template>

<script>
	// import titlecom from '@/components/title/title.vue'
	import navigation from '@/components/navigation/navigation.vue'
	import logocom from '@/components/logo/logo.vue';

	export default {
		data() {
			return {}
		},
		components: {
			navigation,
			logocom

		},
		created() {
			let flag = navigator.userAgent.match(
				/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
			)
			if (!flag) {
				this.$router.push({
					path: '/guide'
				})
			}

		},
	}
</script>

<style lang="scss" scoped>
	@import '@/assets/style/style.scss';

	p {
		margin: 10px 0;

	}
</style>
